import { render, staticRenderFns } from "./Jixiaoman.vue?vue&type=template&id=246554a7&scoped=true&"
import script from "./Jixiaoman.vue?vue&type=script&lang=js&"
export * from "./Jixiaoman.vue?vue&type=script&lang=js&"
import style0 from "./Jixiaoman.vue?vue&type=style&index=0&id=246554a7&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "246554a7",
  null
  
)

export default component.exports